export const ITEMS_PER_PAGE = 30; // Keep sync with backend - Thread.MSGS_PER_THREAD_PAGE
export const POST_DETAIL_MENU_MORE = 'POST_DETAIL_MENU_MORE';

import { ACTIVE_SERVER_ID } from 'mk/settings';
import {
    PostDetailPageState,
    PostDetailState,
    PostDetailVirtualPageState,
} from 'mk2/apps/forum/containers/PostDetail/PostDetail.reducers';
import { LoadingState } from 'mk2/reducers/loadingState';

export const initialPostDetailState: PostDetailState = {
    pages: {},
    virtualPages: {},
    numberOfPages: null,
    contestId: null,
    contestAlreadyParticipated: false,
    commentsWithComplaintIds: [],
    commentToBeHighlighted: null,
    similarPostIds: [],
    recentPostIds: [],
    counselling: null,
    brandDaysCampaignId: null,
    brandDaysPostsIds: [],
    isMyAnonymousPost: false,
    backlinksBoxId: null,

    eshopProductsHeaderIds: [],
    eshopProductsIds: [],
    eshopProductsFooterIds: [],

    eshopProductsOfEshopNodes: null,

    promoReviewArticlesHeaderIds: [],
    promoReviewArticlesMiddleIds: [],
    promoReviewArticlesFooterIds: [],

};

export const initialPostDetailPageState: PostDetailPageState = {
    commentIds: null,
    loadingState: LoadingState.INIT,
    errorMessage: null,
};

export const initialPostDetailVirtualPageState: PostDetailVirtualPageState = {
    loadingState: LoadingState.INIT,
    errorMessage: null,
};

export const ARTICLE_IDS_TO_HIDE_WHEN_PREGNANCY_NEWSLETTER_IS_SHOWN = {
    201: [76, 9052],
    202: [4989, 8078],
}[ACTIVE_SERVER_ID];
